import {
  usePatientCareTeamCaregiverQuery,
  usePatientContactInformationQuery,
} from '@common/cache';
import { useNavigate } from 'react-router-dom';
import { paths } from '@types';
import dayjs from 'dayjs';

export const useDetailsCard = (
  patient: paths[`/patient/{patient_id}`]['get']['responses']['200']['content']['application/json'],
) => {
  const navigate = useNavigate();
  // const logo = usePatientLogoQuery({ patient_id: patient.id });
  const { data: caregiver } = usePatientCareTeamCaregiverQuery(patient.id);
  const { data: patientContactInformation } = usePatientContactInformationQuery(
    {
      patient_id: patient.id,
    },
  );

  // const [logoSrc, setLogoSrc] = useState<string | undefined>(undefined);

  const handleNavigateToAllPatients = (building_id: string) => {
    navigate('/patient/list/all', {
      state: `${building_id}`,
    });
  };

  // useEffect(() => {
  //   const objectUrl = logo.data ? URL.createObjectURL(logo.data) : undefined;
  //   setLogoSrc(objectUrl);
  //   return () => {
  //     if (objectUrl) {
  //       URL.revokeObjectURL(objectUrl);
  //     }
  //   };
  // }, [logo.data]);

  const isEmailOverflowing = patient.contact_information.email.length > 25;

  const currentFormattedDate = dayjs()
    .tz(patient?.local_timezone)
    .format('h:mm A (z), dddd, MMM D');

  return {
    handleNavigateToAllPatients,
    caregiver,
    isEmailOverflowing,
    // logoSrc,
    contactPersonIsCaregiver: patientContactInformation?.type === 'Caregiver',
    currentFormattedDate,
  };
};
